import type {PartialOptions} from "../../../../../../stem-core/ui/UIBase";
import {UI} from "../../../../../../stem-core/ui/UIBase";
import {
    AmazonPayLogo,
    AmExIcon,
    DinersClubIcon,
    DiscoverIcon,
    JCBIcon,
    MasterCardIcon,
    UnionPayIcon,
    VisaIcon, WalletPaymentCardIcon
} from "../../../../../../core/ui/SVGElements.jsx";

const CARD_ICON_CLASS = {
    MASTERCARD: MasterCardIcon,
    VISA: VisaIcon,
    AMEX: AmExIcon,
    DISCOVER: DiscoverIcon,
    DINERS_CLUB: DinersClubIcon,
    JCB: JCBIcon,
    UNION_PAY: UnionPayIcon,
    AMAZON_PAY: AmazonPayLogo, // TODO @cleanup wrong size
    BLINK: WalletPaymentCardIcon,
};

class BrandedCardIcon {
    static cardBrands: Record<string, string> = {
        MASTERCARD: "mastercard",
        VISA: "visa",
        AMEX: "amex",
        DISCOVER: "discover",
        DINERS_CLUB: "diners club",
        JCB: "jcb",
        UNION_PAY: "unionpay",
        AMAZON_PAY: "amazonpay",
    };

    static getIconClassByBrand(brand: string) {
        for (const key of Object.keys(this.cardBrands)) {
            if (brand && this.cardBrands[key].toUpperCase() === brand.toUpperCase() && CARD_ICON_CLASS[key]) {
                return CARD_ICON_CLASS[key];
            }
        }

        return this.getDefaultIconClass();
    }

    static getDefaultIconClass() {
        return CARD_ICON_CLASS.BLINK;
    }
}

// TODO @cleanup this should be a function probably
interface PaymentMethodIconOptions {
    brand?: any;
    size?: any;
}

export class PaymentMethodIcon extends UI.Element<PaymentMethodIconOptions> {
    getDefaultOptions(): PartialOptions<PaymentMethodIcon> {
        return {
            ...super.getDefaultOptions(),
            brand: "",
            size: null,
        };
    }

    render() {
        const {brand, size} = this.options;
        const IconClass = BrandedCardIcon.getIconClassByBrand(brand);
        const iconProperties: Record<string, any> = {};

        if (size) {
            iconProperties.size = size;
        }

        return <IconClass {...iconProperties}/>;
    }
}
